var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYogaBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9177 10.688C21.8238 10.7229 21.7274 10.7578 21.6283 10.7928C19.5827 11.5145 16.4161 12.25 11.9999 12.25C7.58373 12.25 4.41714 11.5145 2.37156 10.7928C2.27248 10.7578 2.17602 10.7229 2.08215 10.688C2.29529 9.06204 2.89918 7.55896 3.7965 6.27612C5.73949 7.02827 8.51302 7.75 11.9999 7.75C15.4868 7.75 18.2604 7.02827 20.2033 6.27612C21.1007 7.55896 21.7046 9.06204 21.9177 10.688Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.2519C19.794 13.0145 16.4989 13.75 12 13.75C7.50111 13.75 4.20598 13.0145 2 12.2519C2.03549 13.6871 2.37346 15.0473 2.95259 16.2711C3.29609 16.4403 3.69627 16.6218 4.1511 16.8036C5.95155 17.5236 8.60788 18.25 12 18.25C15.3921 18.25 18.0484 17.5236 19.8489 16.8036C20.3037 16.6218 20.7039 16.4403 21.0474 16.2711C21.6265 15.0473 21.9645 13.6871 22 12.2519Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C14.824 2 17.3747 3.16988 19.1936 5.0513C17.4274 5.68114 15.0018 6.25 12 6.25C8.99818 6.25 6.57257 5.68114 4.8064 5.0513C6.62528 3.16988 9.17598 2 12 2Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6045 18.4971C17.7065 19.1636 15.143 19.75 12.0001 19.75C8.85703 19.75 6.29363 19.1636 4.39563 18.4971C6.23031 20.6411 8.95644 22 12.0001 22C15.0437 22 17.7698 20.6411 19.6045 18.4971Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaBall);
export default __webpack_public_path__ + "static/media/yoga-ball.be6ba367de9f348d332f6db47d1916f0.svg";
export { ForwardRef as ReactComponent };